// extracted by mini-css-extract-plugin
export var dropdown = "navbar-module--dropdown--51488";
export var dropdownMenu = "navbar-module--dropdown-menu--4aef2";
export var item = "navbar-module--item--d28c3";
export var menuIcon = "navbar-module--menuIcon--b6731";
export var menuItem = "navbar-module--menuItem--b47a1";
export var nav = "navbar-module--nav--affb7";
export var subMenu = "navbar-module--subMenu--2dc8b";
export var subMenuItems = "navbar-module--subMenuItems--ff919";